import { JobService } from 'src/app/shared/services/job.service';
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {
  constructor(
    private translate: TranslateService,
    private jobService: JobService
  ) {
    this.translate.addLangs(['English', 'ಕನ್ನಡ']);
    this.translate.setDefaultLang('English');
    this.translate.use('English');
  }

  ngOnInit(){
     window.addEventListener('DeviceStatus', this.reloadAppOnForeground);
  }

  reloadAppOnForeground = (event: Event) => {
  const customEvent = event as CustomEvent<{ state: string }>;

  if (customEvent.detail.state === 'foreground' || customEvent.detail.state === 'notification') {
    this.jobService.notifyAppVisibilityChange()
    // window.location.reload();
  }
};
}
